import AddOnsColorTuorqouise from './IconsAddOnsColorTuorqouise';
import AddOnsColorViolet from './IconsAddOnsColorViolet';
import AddOnsWhite from './IconsAddOnsWhite';
import AddOns from './IconsAddOns';
import App from './IconsApp';
import ArrowBack from './IconsArrowBack';
import ArrowDown from './IconsArrowDown';
import ArrowForward from './IconsArrowForward';
import ArrowQuit from './IconsArrowQuit';
import ArrowUp from './IconsArrowUp';
import BackArrow from './IconsBackArrow';
import Bell from './IconsBell';
import BitbotFailed from './IconsBitbotFailed';
import Bitbot from './IconsBitbot';
import BitbucketFill from './IconsBitbucketFill';
import Bitbucket from './IconsBitbucket';
import BitriseCertified from './IconsBitriseCertified';
import Book from './IconsBook';
import BranchBranch from './IconsBranchBranch';
import BranchCommit from './IconsBranchCommit';
import BranchPull from './IconsBranchPull';
import BranchPush from './IconsBranchPush';
import BranchTag from './IconsBranchTag';
import Bug from './IconsBug';
import Build from './IconsBuild';
import BuildstatusAbortedSolid from './IconsBuildstatusAbortedSolid';
import BuildstatusAborted from './IconsBuildstatusAborted';
import BuildstatusFailedSolid from './IconsBuildstatusFailedSolid';
import BuildstatusFailed from './IconsBuildstatusFailed';
import BuildstatusLoadingAnimated from './IconsBuildstatusLoadingAnimated';
import BuildstatusLoading from './IconsBuildstatusLoading';
import BuildstatusLoadingeeehhWhite from './IconsBuildstatusLoadingeeehhWhite';
import BuildstatusLoadingeeehh from './IconsBuildstatusLoadingeeehh';
import BuildstatusNeverbuilt from './IconsBuildstatusNeverbuilt';
import BuildstatusSuccessfulSolid from './IconsBuildstatusSuccessfulSolid';
import BuildstatusSuccessful from './IconsBuildstatusSuccessful';
import Calendar from './IconsCalendar';
import Chain from './IconsChain';
import ChangePlan from './IconsChangePlan';
import ChatMessage from './IconsChatMessage';
import Chat from './IconsChat';
import ChevronDown from './IconsChevronDown';
import ChevronLeft from './IconsChevronLeft';
import ChevronRight from './IconsChevronRight';
import ChevronUp from './IconsChevronUp';
import Clock from './IconsClock';
import CloseSmall from './IconsCloseSmall';
import Code from './IconsCode';
import Coffee from './IconsCoffee';
import Credit from './IconsCredit';
import DeleteNope from './IconsDeleteNope';
import Deployment from './IconsDeployment';
import Doc from './IconsDoc';
import Dollars from './IconsDollars';
import Download from './IconsDownload';
import DropdownArrows from './IconsDropdownArrows';
import Dudes from './IconsDudes';
import Duplicate from './IconsDuplicate';
import Enterprise from './IconsEnterprise';
import ErrorGeneral from './IconsErrorGeneral';
import Eye from './IconsEye';
import FileDoc from './IconsFileDoc';
import FilePdf from './IconsFilePdf';
import FilePlist from './IconsFilePlist';
import FileZip from './IconsFileZip';
import Filter from './IconsFilter';
import Flag from './IconsFlag';
import Folder from './IconsFolder';
import FullscreenExit from './IconsFullscreenExit';
import Fullscreen from './IconsFullscreen';
import Github from './IconsGithub';
import GitlabFill from './IconsGitlabFill';
import Gitlab from './IconsGitlab';
import Globe from './IconsGlobe';
import Group from './IconsGroup';
import Heart from './IconsHeart';
import History from './IconsHistory';
import Image from './IconsImage';
import Info from './IconsInfo';
import Integrations from './IconsIntegrations';
import Interaction from './IconsInteraction';
import Invoice from './IconsInvoice';
import Key from './IconsKey';
import Laptop from './IconsLaptop';
import Lightbulb from './IconsLightbulb';
import Lock from './IconsLock';
import Login from './IconsLogin';
import Logout from './IconsLogout';
import Magnifier from './IconsMagnifier';
import Mail from './IconsMail';
import MenuGrid from './IconsMenuGrid';
import MenuHamburger from './IconsMenuHamburger';
import Message from './IconsMessage';
import MinusClose from './IconsMinusClose';
import MinusRemove from './IconsMinusRemove';
import Mobile from './IconsMobile';
import Monitoring from './IconsMonitoring';
import More from './IconsMore';
import NoTie from './IconsNoTie';
import Numero from './IconsNumero';
import OpenInBrowser from './IconsOpenInBrowser';
import Overview from './IconsOverview';
import Owner from './IconsOwner';
import Pause from './IconsPause';
import Pencil from './IconsPencil';
import Percent from './IconsPercent';
import Person from './IconsPerson';
import PlatformsAndroid from './IconsPlatformsAndroid';
import PlatformsApple from './IconsPlatformsApple';
import PlatformsCordova from './IconsPlatformsCordova';
import PlatformsFastlane from './IconsPlatformsFastlane';
import PlatformsFlutter from './IconsPlatformsFlutter';
import PlatformsGo from './IconsPlatformsGo';
import PlatformsIonic from './IconsPlatformsIonic';
import PlatformsMacos from './IconsPlatformsMacos';
import PlatformsNodejs from './IconsPlatformsNodejs';
import PlatformsOther from './IconsPlatformsOther';
import PlatformsReact from './IconsPlatformsReact';
import PlatformsXamarin from './IconsPlatformsXamarin';
import Play from './IconsPlay';
import PlusAdd from './IconsPlusAdd';
import PlusOpen from './IconsPlusOpen';
import Power from './IconsPower';
import Refresh from './IconsRefresh';
import Request from './IconsRequest';
import Responsiveness from './IconsResponsiveness';
import Save from './IconsSave';
import SecurityShield from './IconsSecurityShield';
import Settings from './IconsSettings';
import Ship from './IconsShip';
import Shuffle from './IconsShuffle';
import Stability from './IconsStability';
import Stack from './IconsStack';
import Status from './IconsStatus';
import StepThirdParty from './IconsStepThirdParty';
import StepUpgradeCircle from './IconsStepUpgradeCircle';
import StepUpgrade from './IconsStepUpgrade';
import StepVersionOk from './IconsStepVersionOk';
import StepsColorTuorqouise from './IconsStepsColorTuorqouise';
import StepsColorViolet from './IconsStepsColorViolet';
import StepsWhite from './IconsStepsWhite';
import Steps from './IconsSteps';
import Stopwatch from './IconsStopwatch';
import Support from './IconsSupport';
import Switch from './IconsSwitch';
import TestFailed from './IconsTestFailed';
import TestInconclusive from './IconsTestInconclusive';
import TestInfo from './IconsTestInfo';
import TestSkipped from './IconsTestSkipped';
import TestSuccess from './IconsTestSuccess';
import TestWarning from './IconsTestWarning';
import Tick from './IconsTick';
import Time from './IconsTime';
import Trace from './IconsTrace';
import Trash from './IconsTrash';
import Trigger from './IconsTrigger';
import Twitter from './IconsTwitter';
import ValidateShield from './IconsValidateShield';
import Warning from './IconsWarning';
import Window from './IconsWindow';
import WorkflowFlow from './IconsWorkflowFlow';
import Workflow from './IconsWorkflow';
import Wow from './IconsWow';

export type TypeIconName =
  'AddOnsColorTuorqouise' |
  'AddOnsColorViolet' |
  'AddOnsWhite' |
  'AddOns' |
  'App' |
  'ArrowBack' |
  'ArrowDown' |
  'ArrowForward' |
  'ArrowQuit' |
  'ArrowUp' |
  'BackArrow' |
  'Bell' |
  'BitbotFailed' |
  'Bitbot' |
  'BitbucketFill' |
  'Bitbucket' |
  'BitriseCertified' |
  'Book' |
  'BranchBranch' |
  'BranchCommit' |
  'BranchPull' |
  'BranchPush' |
  'BranchTag' |
  'Bug' |
  'Build' |
  'BuildstatusAbortedSolid' |
  'BuildstatusAborted' |
  'BuildstatusFailedSolid' |
  'BuildstatusFailed' |
  'BuildstatusLoadingAnimated' |
  'BuildstatusLoading' |
  'BuildstatusLoadingeeehhWhite' |
  'BuildstatusLoadingeeehh' |
  'BuildstatusNeverbuilt' |
  'BuildstatusSuccessfulSolid' |
  'BuildstatusSuccessful' |
  'Calendar' |
  'Chain' |
  'ChangePlan' |
  'ChatMessage' |
  'Chat' |
  'ChevronDown' |
  'ChevronLeft' |
  'ChevronRight' |
  'ChevronUp' |
  'Clock' |
  'CloseSmall' |
  'Code' |
  'Coffee' |
  'Credit' |
  'DeleteNope' |
  'Deployment' |
  'Doc' |
  'Dollars' |
  'Download' |
  'DropdownArrows' |
  'Dudes' |
  'Duplicate' |
  'Enterprise' |
  'ErrorGeneral' |
  'Eye' |
  'FileDoc' |
  'FilePdf' |
  'FilePlist' |
  'FileZip' |
  'Filter' |
  'Flag' |
  'Folder' |
  'FullscreenExit' |
  'Fullscreen' |
  'Github' |
  'GitlabFill' |
  'Gitlab' |
  'Globe' |
  'Group' |
  'Heart' |
  'History' |
  'Image' |
  'Info' |
  'Integrations' |
  'Interaction' |
  'Invoice' |
  'Key' |
  'Laptop' |
  'Lightbulb' |
  'Lock' |
  'Login' |
  'Logout' |
  'Magnifier' |
  'Mail' |
  'MenuGrid' |
  'MenuHamburger' |
  'Message' |
  'MinusClose' |
  'MinusRemove' |
  'Mobile' |
  'Monitoring' |
  'More' |
  'NoTie' |
  'Numero' |
  'OpenInBrowser' |
  'Overview' |
  'Owner' |
  'Pause' |
  'Pencil' |
  'Percent' |
  'Person' |
  'PlatformsAndroid' |
  'PlatformsApple' |
  'PlatformsCordova' |
  'PlatformsFastlane' |
  'PlatformsFlutter' |
  'PlatformsGo' |
  'PlatformsIonic' |
  'PlatformsMacos' |
  'PlatformsNodejs' |
  'PlatformsOther' |
  'PlatformsReact' |
  'PlatformsXamarin' |
  'Play' |
  'PlusAdd' |
  'PlusOpen' |
  'Power' |
  'Refresh' |
  'Request' |
  'Responsiveness' |
  'Save' |
  'SecurityShield' |
  'Settings' |
  'Ship' |
  'Shuffle' |
  'Stability' |
  'Stack' |
  'Status' |
  'StepThirdParty' |
  'StepUpgradeCircle' |
  'StepUpgrade' |
  'StepVersionOk' |
  'StepsColorTuorqouise' |
  'StepsColorViolet' |
  'StepsWhite' |
  'Steps' |
  'Stopwatch' |
  'Support' |
  'Switch' |
  'TestFailed' |
  'TestInconclusive' |
  'TestInfo' |
  'TestSkipped' |
  'TestSuccess' |
  'TestWarning' |
  'Tick' |
  'Time' |
  'Trace' |
  'Trash' |
  'Trigger' |
  'Twitter' |
  'ValidateShield' |
  'Warning' |
  'Window' |
  'WorkflowFlow' |
  'Workflow' |
  'Wow';

export const IconList: TypeIconName[] = [
  'AddOnsColorTuorqouise',
  'AddOnsColorViolet',
  'AddOnsWhite',
  'AddOns',
  'App',
  'ArrowBack',
  'ArrowDown',
  'ArrowForward',
  'ArrowQuit',
  'ArrowUp',
  'BackArrow',
  'Bell',
  'BitbotFailed',
  'Bitbot',
  'BitbucketFill',
  'Bitbucket',
  'BitriseCertified',
  'Book',
  'BranchBranch',
  'BranchCommit',
  'BranchPull',
  'BranchPush',
  'BranchTag',
  'Bug',
  'Build',
  'BuildstatusAbortedSolid',
  'BuildstatusAborted',
  'BuildstatusFailedSolid',
  'BuildstatusFailed',
  'BuildstatusLoadingAnimated',
  'BuildstatusLoading',
  'BuildstatusLoadingeeehhWhite',
  'BuildstatusLoadingeeehh',
  'BuildstatusNeverbuilt',
  'BuildstatusSuccessfulSolid',
  'BuildstatusSuccessful',
  'Calendar',
  'Chain',
  'ChangePlan',
  'ChatMessage',
  'Chat',
  'ChevronDown',
  'ChevronLeft',
  'ChevronRight',
  'ChevronUp',
  'Clock',
  'CloseSmall',
  'Code',
  'Coffee',
  'Credit',
  'DeleteNope',
  'Deployment',
  'Doc',
  'Dollars',
  'Download',
  'DropdownArrows',
  'Dudes',
  'Duplicate',
  'Enterprise',
  'ErrorGeneral',
  'Eye',
  'FileDoc',
  'FilePdf',
  'FilePlist',
  'FileZip',
  'Filter',
  'Flag',
  'Folder',
  'FullscreenExit',
  'Fullscreen',
  'Github',
  'GitlabFill',
  'Gitlab',
  'Globe',
  'Group',
  'Heart',
  'History',
  'Image',
  'Info',
  'Integrations',
  'Interaction',
  'Invoice',
  'Key',
  'Laptop',
  'Lightbulb',
  'Lock',
  'Login',
  'Logout',
  'Magnifier',
  'Mail',
  'MenuGrid',
  'MenuHamburger',
  'Message',
  'MinusClose',
  'MinusRemove',
  'Mobile',
  'Monitoring',
  'More',
  'NoTie',
  'Numero',
  'OpenInBrowser',
  'Overview',
  'Owner',
  'Pause',
  'Pencil',
  'Percent',
  'Person',
  'PlatformsAndroid',
  'PlatformsApple',
  'PlatformsCordova',
  'PlatformsFastlane',
  'PlatformsFlutter',
  'PlatformsGo',
  'PlatformsIonic',
  'PlatformsMacos',
  'PlatformsNodejs',
  'PlatformsOther',
  'PlatformsReact',
  'PlatformsXamarin',
  'Play',
  'PlusAdd',
  'PlusOpen',
  'Power',
  'Refresh',
  'Request',
  'Responsiveness',
  'Save',
  'SecurityShield',
  'Settings',
  'Ship',
  'Shuffle',
  'Stability',
  'Stack',
  'Status',
  'StepThirdParty',
  'StepUpgradeCircle',
  'StepUpgrade',
  'StepVersionOk',
  'StepsColorTuorqouise',
  'StepsColorViolet',
  'StepsWhite',
  'Steps',
  'Stopwatch',
  'Support',
  'Switch',
  'TestFailed',
  'TestInconclusive',
  'TestInfo',
  'TestSkipped',
  'TestSuccess',
  'TestWarning',
  'Tick',
  'Time',
  'Trace',
  'Trash',
  'Trigger',
  'Twitter',
  'ValidateShield',
  'Warning',
  'Window',
  'WorkflowFlow',
  'Workflow',
  'Wow',
];

export const IconMap: { [key in TypeIconName]: React.FC<React.SVGProps<SVGSVGElement>> } = {
  AddOnsColorTuorqouise,
  AddOnsColorViolet,
  AddOnsWhite,
  AddOns,
  App,
  ArrowBack,
  ArrowDown,
  ArrowForward,
  ArrowQuit,
  ArrowUp,
  BackArrow,
  Bell,
  BitbotFailed,
  Bitbot,
  BitbucketFill,
  Bitbucket,
  BitriseCertified,
  Book,
  BranchBranch,
  BranchCommit,
  BranchPull,
  BranchPush,
  BranchTag,
  Bug,
  Build,
  BuildstatusAbortedSolid,
  BuildstatusAborted,
  BuildstatusFailedSolid,
  BuildstatusFailed,
  BuildstatusLoadingAnimated,
  BuildstatusLoading,
  BuildstatusLoadingeeehhWhite,
  BuildstatusLoadingeeehh,
  BuildstatusNeverbuilt,
  BuildstatusSuccessfulSolid,
  BuildstatusSuccessful,
  Calendar,
  Chain,
  ChangePlan,
  ChatMessage,
  Chat,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Clock,
  CloseSmall,
  Code,
  Coffee,
  Credit,
  DeleteNope,
  Deployment,
  Doc,
  Dollars,
  Download,
  DropdownArrows,
  Dudes,
  Duplicate,
  Enterprise,
  ErrorGeneral,
  Eye,
  FileDoc,
  FilePdf,
  FilePlist,
  FileZip,
  Filter,
  Flag,
  Folder,
  FullscreenExit,
  Fullscreen,
  Github,
  GitlabFill,
  Gitlab,
  Globe,
  Group,
  Heart,
  History,
  Image,
  Info,
  Integrations,
  Interaction,
  Invoice,
  Key,
  Laptop,
  Lightbulb,
  Lock,
  Login,
  Logout,
  Magnifier,
  Mail,
  MenuGrid,
  MenuHamburger,
  Message,
  MinusClose,
  MinusRemove,
  Mobile,
  Monitoring,
  More,
  NoTie,
  Numero,
  OpenInBrowser,
  Overview,
  Owner,
  Pause,
  Pencil,
  Percent,
  Person,
  PlatformsAndroid,
  PlatformsApple,
  PlatformsCordova,
  PlatformsFastlane,
  PlatformsFlutter,
  PlatformsGo,
  PlatformsIonic,
  PlatformsMacos,
  PlatformsNodejs,
  PlatformsOther,
  PlatformsReact,
  PlatformsXamarin,
  Play,
  PlusAdd,
  PlusOpen,
  Power,
  Refresh,
  Request,
  Responsiveness,
  Save,
  SecurityShield,
  Settings,
  Ship,
  Shuffle,
  Stability,
  Stack,
  Status,
  StepThirdParty,
  StepUpgradeCircle,
  StepUpgrade,
  StepVersionOk,
  StepsColorTuorqouise,
  StepsColorViolet,
  StepsWhite,
  Steps,
  Stopwatch,
  Support,
  Switch,
  TestFailed,
  TestInconclusive,
  TestInfo,
  TestSkipped,
  TestSuccess,
  TestWarning,
  Tick,
  Time,
  Trace,
  Trash,
  Trigger,
  Twitter,
  ValidateShield,
  Warning,
  Window,
  WorkflowFlow,
  Workflow,
  Wow,
};
